module.exports = __webpack_public_path__ + "static/media/premiers-bg.d4004c7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PremiersWinnersBanner/premiers-bg.jpg
// module id = 1359
// module chunks = 0